import { LAST_ACTIVITY_KEY, PROFILE_KEY, SESSOIN_EXPIRY_KEY } from "../utils/Constants";

const LEGACY_SESSION_KEYS = ["roles", "GROUP_ADMIN"];

export const localStorageHelper = {
    load(key: string) {
        const stored = localStorage.getItem(key);
        return stored == null ? undefined : JSON.parse(stored);
    },
    store(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    remove(key: string) {
        localStorage.removeItem(key);
    },
    clearSession() {
        [PROFILE_KEY, SESSOIN_EXPIRY_KEY, LAST_ACTIVITY_KEY, ...LEGACY_SESSION_KEYS].forEach((key) =>
            localStorage.removeItem(key)
        );
    },
};
